import React from "react";
import { Filter, ReferenceInput, SelectInput } from "react-admin";

const Filters = (props) => {
	return (
		<Filter {...props} variant="outlined">
			<ReferenceInput
				source="contest_id"
				fullWidth
				reference="contests"
				resettable
				alwaysOn
			>
				<SelectInput optionText="title" />
			</ReferenceInput>
		</Filter>
	);
};
export default Filters;
